import './App.css';
import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
// import Home from './components/Home';
import {AuthProviderWrapper} from "./components/AuthContext";
import MainView from "./MainView";
import {Dashboard} from "./components/Dashboard";
import {MyRequests} from "./components/MyRequests";
import {MasterCalendarForm} from "./components/MasterCalendarForm";
import {SaveTheDateForm} from "./components/Forms/SaveTheDateForm";
import {JobApplicationForm} from "./components/Forms/JobApplicationForm";
import {Administrator} from "./components/Administrator";
import {RoomScheduler} from "./components/RoomScheduler";
import {PurchaseOrders} from "./components/PurchaseOrders";
import AccountsVendorsScreen from "./components/AccountsVendorsScreen";
import {LandingPage} from "./components/LandingPage";
import PastorsTools from "./components/PastorsTools/PastorsTools";
import {ApprovalPage} from "./components/ApprovalPage";

function App() {
    return (
        <AuthProviderWrapper>
            <Router>
                <div>
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/apply" element={<JobApplicationForm />} />
                        <Route path="/approve/:formId" element={<ApprovalPage />} />
                        {/*<Route path="/profile" element={<UserProfile />} />*/}
                        <Route path="/home" element={<MainView />}>
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="request" element={<MyRequests />} />
                            <Route path="administrator" element={<Administrator />} />
                            <Route path="form/:id" element={<MasterCalendarForm />} />
                            <Route path="form" element={<MasterCalendarForm />} />
                            <Route path="save-the-date" element={<SaveTheDateForm />} />
                            <Route path="schedule" element={<RoomScheduler />} />
                            <Route path="purchase-orders" element={<PurchaseOrders />} />
                            <Route path="accounts-vendors" element={<AccountsVendorsScreen />} />
                            <Route path="pastors-tools" element={<PastorsTools />} />
                        </Route>
                    </Routes>
                </div>
            </Router>
        </AuthProviderWrapper>
    );

  // return (
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.js</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //     </header>
  //   </div>
  // );
}

export default App;
